import { Stack, StackProps, Typography } from '@mui/material';

type MapControlSectionProps = StackProps & { title: string };

export const MapControlSection = ({ title, children, gap = 1, ...props }: MapControlSectionProps) => {
  return (
    <Stack {...props} gap={gap}>
      <Typography variant="subtitle2" component="span">
        {title}
      </Typography>
      {children}
    </Stack>
  );
};
